import { render, staticRenderFns } from "./downloadRecord.vue?vue&type=template&id=564fe411&scoped=true"
import script from "./downloadRecord.vue?vue&type=script&lang=js"
export * from "./downloadRecord.vue?vue&type=script&lang=js"
import style0 from "./downloadRecord.vue?vue&type=style&index=0&id=564fe411&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564fe411",
  null
  
)

export default component.exports